'use strict'

/**
 * RoutineComposer component which can be appointed to a specific region by supplying it with
 * the right properties.
 *
 * options:{
 *  region:<marionette region>
 *  type:<string>(dali|color|...)
 *  deviceType:<string>,
 *  routine:<object>
 * }
 */

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')
var Moment = require('moment')
var View = require('./view')
var Helpers = require('../../common/helpers')

var RoutineComposer = Marionette.Object.extend({
  initialize: function (options) {

    var self = this

    // filter collection
    var RoutineModel = Backbone.Model.extend({})
    var RoutineCollection = Backbone.Collection.extend({ model: RoutineModel })

    self.routineCollection = new RoutineCollection()

    // var routineData = self.routineAddHour(_.clone(self.options.routine))
    var routineData = _.clone(self.options.routine)

    self.routineCollection.add(routineData)

    self.layout = self.getLayout(self.routineCollection)

    
    self.listenTo(self.layout, 'control:send-command', (data) => {
      self.triggerMethod('control:send-command', data);
    })

    self.options.region.show(self.layout)
  },
  routineAddHour: function (commands) {
    _.forEach(commands, (command) => {
      if (!command.time) return
      command.time += 3600
    })
    return commands
  },
  routineRemoveHour: function (commands) {
    _.forEach(commands, (command) => {
      if (!command.time) return
      command.time -= 3600
    })
    return commands
  },
  /**
   * Exports the routine in the right data format
   */
  getRoutine: function () {
    var self = this
    // get routine information from the view
    var composerValues = this.layout.getRoutine()
    var routineFormat = []
    var commands = []

    // convert the composerValues to the correct routine format
    _.forEach(composerValues, function (data) {
      // var routine = {
      //   commands: [],
      // //  time: data.time
      // }
      switch (self.options.type) {
        case 'dimming':

          commands.push({
            key: 'dimming.set.max_current',
            value: data.value,
            time: data.time
          })
          break
        case 'dali':
          commands.push({
            key: 'dali.set.arc_power',
            value: data.value,
            time: data.time
          })
          break
        case 'color_rgbw':
          // console.log(data.properties)
          //   var color = data.properties['ring_one'] || '000000'

            var colorChannels = [0,0,0,0];
            colorChannels[0] = parseInt(data.properties['color_r']) || 0;
            colorChannels[1] = parseInt(data.properties['color_g']) || 0;
            colorChannels[2] = parseInt(data.properties['color_b']) || 0;
            colorChannels[3] = parseInt(data.properties['color_w']) || 0;

            // restrain the values
            _.forEach(colorChannels, (value, key) => {
              if (value > 254) {
                value = 254;
              } else if (value < 0) {
                value = 0;
              }
              colorChannels[key] = value;
            })

            // convert to hex
            var hexChannels = [];
            _.forEach(colorChannels, (value, key) => {
              hexChannels[key] = Helpers.dec2hex(value);
            })
     
  
            var color = {
              key: 'color_rgbw.set.color',
              value: hexChannels.join(""),
              time: data.time
            }
            commands.push(color)        
          break;
        case 'color':
          var ringOneColor = data.properties['ring_one'] || '000000'
          var ringTwoColor = data.properties['ring_two'] || '000000'

          var ring_one = {
            key: 'color.set.led1',
            value: ringOneColor,
            time: data.time
          }
          var ring_two = {
            key: 'color.set.led2',
            value: ringTwoColor,
            time: data.time
          }
          commands.push(ring_one)
          commands.push(ring_two)
          break
      }
    })

    // convert the routine to utc
   // commands = self.routineRemoveHour(commands)

    return commands
  },
  /* Views ----------------------------------------------------------------- */
  getLayout: function (collection) {
    return new View.Layout({collection: collection, type: this.options.type, dayRoutine: this.options.dayRoutine, legacyTimeOffset:this.options.legacyTimeOffset})
  }
})

module.exports = RoutineComposer



// WEBPACK FOOTER //
// ./js/components/routine-composer/index.js